import {getPullRequestTabSuffix} from '@github-ui/paths'
import {useLocation} from '@github-ui/react-router'
import {DotIcon} from '@primer/octicons-react'
import {BranchName, NavList} from '@primer/react'

import {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'
import {getEffectiveEntryLineClass} from '../../../helpers/get-effective-entry-line-class'
import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-types'
import {EffectiveEntryStatusIcon} from './EffectiveEntryStatusIcon'
import {EffectiveEntryStatusLabel} from './EffectiveEntryStatusLabel'
import {StackEntryNavItem} from './StackEntryNavItem'
import stackListStyles from './StackList.module.css'
import styles from './StackEntryPreviewList.module.css'

/**
 * Lists the stacked pull requests a confirmation step will act on, ending with the branch they merge into.
 */
export function StackEntryPreviewList({
  'aria-label': ariaLabel,
  baseRefName,
  entries,
}: {
  'aria-label': string
  baseRefName: string
  entries: readonly StackSectionStackEntry[]
}) {
  const {pathname} = useLocation()
  const tabSuffix = getPullRequestTabSuffix(pathname)

  return (
    <div className={styles.StackEntries}>
      <NavList className={stackListStyles.stackNavList} aria-label={ariaLabel}>
        {entries.map(entry => {
          const effectiveEntryStatus = entry.effectiveEntryStatus ?? EffectiveEntryStatus.NotReady

          return (
            <StackEntryNavItem
              key={entry.pull.number}
              entry={entry}
              tabSuffix={tabSuffix}
              className={getEffectiveEntryLineClass(entry)}
              isTitleMuted={false}
              leadingVisual={<EffectiveEntryStatusIcon status={effectiveEntryStatus} />}
              trailingVisual={<EffectiveEntryStatusLabel status={effectiveEntryStatus} />}
            />
          )
        })}
        <li className={stackListStyles.branchItem}>
          <span className={stackListStyles.branchItemContent}>
            <DotIcon className="color-fg-muted" />
            <BranchName as="span">{baseRefName}</BranchName>
          </span>
        </li>
      </NavList>
    </div>
  )
}
